import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {DATA_TRANSFER_ENUM, PathHistory} from './IdfSaleEnums';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';

export const InsertOrderDetails = createAsyncThunk('IDFService/InsertOrderDetails', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('InsertOrderDetails', data);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const InsertOrderDetailsPhoneUpgrade = createAsyncThunk('IDFService/InsertOrderDetailsPhoneUpgrade', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('InsertOrderDetailsPhoneUpgrade', data);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});
export const CreditCardValidation = createAsyncThunk('CreditCard/Validation', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('creditCardValidation', data);
    return result.Body;
  } catch (error) {
    error.isError = true;
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});
export const GetUserDetails = createAsyncThunk('IDFService/GetUserDetails', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetUserDetails', []);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});
export const GetDetailsDeviceUpgrade = createAsyncThunk('IDFService/GetDetailsDeviceUpgrade', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetUserDetails', []);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const GetDeliverySlotsByAdress = createAsyncThunk('Slots/GetDeliverySlotsByAdress', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());

  try {
    const result = await ProviderManager.getProviderData('GetDeliverySlotsByAdress', [data.city, data.street, data.homeNum, true]);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const IsCellcomNumber = createAsyncThunk('IDFService/IsCellcomNumber', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('IsCellcomNumber', [data.phoneNumber]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const IsExternalCompanyNumber = createAsyncThunk('IDFService/IsExternalCompanyNumber', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('IsExternalCompanyNumber', [data.phoneNumber]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});
export const GetCitiesServiceCenters = createAsyncThunk('IDFService/GetCitiesServiceCenters', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetCitiesServiceCenters', []);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});
export const GetProductsList = createAsyncThunk('IDFService/GetProductsList', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetProductsList', []);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});
export const GetProductDetails = createAsyncThunk('IDFService/GetProductDetails', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetProductDetails', [data.modelId, data.isLeasing]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});
export const GetPriceByPaymentCount = createAsyncThunk('IDFService/GetPriceByPaymentCount', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetPriceByPaymentCount', [data.count, data.itemId, data.isLeasing]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const GetCustomerExposure = createAsyncThunk('Ban/GetCustomerExposure', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetCustomerExposure', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});
export const GetOrderDetails = createAsyncThunk('IDFService/GetOrderDetails', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetOrderDetails', []);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const NotifyUserDevice = createAsyncThunk('IDFService/NotifyUserDevice', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('NotifyUserDevice', [data.Email, data.Cat_no, data.Color, data.Phone_Name]);
    return result.Body;
  } catch (error) {
    throw error;
  }
});

export const GetUserSignatureForm = createAsyncThunk('idfSaleBlock/GetUserSignatureForm', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetUserSignatureForm', []);
    thunkAPI.dispatch(hideAppLoader());
    if (result.Header.ReturnCodeMessage == 'SUCCESS') {
      return result.Body;
    } else {
      throw result.Header;
    }
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const createWorkOrderAsync = createAsyncThunk('IDFService/createWorkOrderAsync', async (data, thunkAPI) => {
  if (data?.isDisplayLoader) {
    thunkAPI.dispatch(showAppLoader());
  }

  try {
    // const state = thunkAPI.getState().addonsBlock;
    const userDetails = thunkAPI.getState().authentication?.loginData?.userDetails;

    // let serviceName = '';

    // switch (state.flowType) {
    //   case 'service':
    //     serviceName = 'הוספת שירות';
    //     break;
    //   case 'mesh':
    //     serviceName = 'הוספת MESH';
    //     break;
    //   case 'internetSpeed':
    //     serviceName = 'שינוי מהירות';
    //     break;
    // }

    let request = {
      orderType: 'IDF_CONTACT_US',
      identityNumber: userDetails.IDNumber,
      errorCode: 'Z284',
      errorDescription: `פתיחת הו"ע Z284 לצוותון 80000108`,
      subscriber: userDetails.contactNumber,
      banList: [],
      psidList: [],
      movingApartment: null,
      saleJet: null,
      firstName: userDetails.firstName,
      lastName: userDetails.lastName,
    };

    const result = await ProviderManager.getProviderData('createWorkOrder', request);

    // if (data?.isDisplayLoader) {
    //   thunkAPI.dispatch(setSuccessType('LEAD_SUCCESS'));
    // }

    return result?.Body;
  } catch (error) {
  } finally {
    if (data?.isDisplayLoader) {
      thunkAPI.dispatch(hideAppLoader());
    }
  }
});

const convertStringToDateTime = (payload) => {
  const start = `${payload.date}T${payload.selectedHours.startHour}.000Z`;
  const end = `${payload.date}T${payload.selectedHours.endHour}.000Z`;
  const startDateTime = new Date(start);
  const endDateTime = new Date(end);
  const res = {startDateTime: startDateTime, endDateTime: endDateTime};
  return res;
};
const initialState = {
  isShowHeader: true,
  page: '',
  isSaleDone: null,
  magicLink: null,
  selectedPackage: null,
  lineType: '',
  lineNumber: '',
  personalInfoMode: 'ADDRESS',
  selectedAddress: null,
  selectedEmail: null,
  selectedPhoneNumber: null,
  confirmMail: true,
  mailbox: null,
  postalCode: null,
  deliveryMode: '',
  isUsePersonalInfoAddress: false,
  isSimInMailBox: false,
  deliverySelectedFirstName: '',
  deliverySelectedLastName: '',
  deliverySelectedPhoneNumber: '',
  deliveryComments: '',
  deliverySelectedAddress: null,
  pickupServiceCenter: null,
  notifyDeviceList: [],
  userDetails: {},
  joiningForm: {
    fullname: '',
    id: '',
    last4_pn_idf: '',
    sub_agreement: false,
    move_data_by_law: false,
    move_data_to_person: false,
    person_data_move: '',
    dont_move_data: false,
    accept_data_download: false,
    accept_terms: false,
    sign_name_terms: '',
    i_have_signed_willingly: false,
    sign_name_willing: '',
  },
  serviceAccessForm: {
    b144Ind: false,
    allowSpamInd: false,
    gprsRoamInd: false,
    intlInd: true,
    zotInfoInd: false,
    premiumInd: false,
    premium0Ind: false,
    premium1Ind: false,
    zsurfInd: false,
    zotDownConInd: false,
    zotVoteInd: false,
    zotDonateInd: false,
    zotRecContInd: false,
    zcnDownConInd: false,
    zcnRecContInd: false,
  },
  acceptSecurity: false,
  simType: null,
  acceptAuction: false,
  isJoiningFormValid: false,
  isServiceFormValid: false,
  selectedDeliverySlot: {},
  processType: 'DEVICE',
  isLeasing: false,
  selectedPhone: {},
  deviceUpgradeProcessing: false,
  canUpgradePhone: false,
  transactionStatusId: null,
  creditDecision: null,
  nonSeparDepos: null,
  isShowSecurityForm: {isShow: false, error: false},
  isShowAuction: {isShow: false, error: false},
  enableSubmitBtn: true,
  citiesServiceCenters: null,
  pickupDate: null,
  errorReason: '',
  steps: {
    previous: '',
    current: 'PlanSelection',
  },
  phoneFeatureList: [],
  repId: null,
};

const idfSaleBlockSlice = createSlice({
  name: 'idfSaleBlock',
  initialState: initialState,

  reducers: {
    goToPage: (state, action) => {
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    setIsShowHeader: (state, action) => {
      state.isShowHeader = action.payload;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    pushToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return initialState;
    },
    setCurrentStep: (state, action) => {
      state.steps = {
        previous: action.payload.previous ?? '',
        current: action.payload.current,
      };
      return state;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setLineType: (state, action) => {
      state.lineType = action.payload;
    },
    setLineNumber: (state, action) => {
      state.lineNumber = action.payload;
    },
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload.selectedAddress;
    },
    setPersonalInfoMode: (state, action) => {
      state.personalInfoMode = action.payload;
    },
    setSelectedEmail: (state, action) => {
      state.selectedEmail = action.payload;
    },

    setSelectedPhoneNumber: (state, action) => {
      state.selectedPhoneNumber = action.payload;
    },
    setConfirmMail: (state, action) => {
      state.confirmMail = action.payload;
    },
    setMailbox: (state, action) => {
      state.mailbox = action.payload;
    },
    setPostalCode: (state, action) => {
      state.postalCode = action.payload;
    },
    setDeliveryMode: (state, action) => {
      state.deliveryMode = action.payload;
    },
    setIsUsePersonalInfoAddress: (state, action) => {
      state.isUsePersonalInfoAddress = action.payload;
      if (action.payload) {
        state.deliverySelectedAddress = state.selectedAddress;
      } else {
        state.deliverySelectedAddress = null;
      }
    },
    setIsSimInMailBox: (state, action) => {
      state.isSimInMailBox = action.payload;
    },
    setDeliverySelectedAddress: (state, action) => {
      if (action.payload) state.deliverySelectedAddress = action.payload.selectedAddress;
    },
    setPickupServiceCenter: (state, action) => {
      state.pickupServiceCenter = action.payload;
    },
    setDeliverySelectedFullName: (state, action) => {
      if (action.payload.target === 'FIRST-NAME') state.deliverySelectedFirstName = action.payload.value;
      if (action.payload.target === 'LAST-NAME') state.deliverySelectedLastName = action.payload.value;
    },
    setDeliverySelectedPhoneNumber: (state, action) => {
      state.deliverySelectedPhoneNumber = action.payload;
    },
    setDeliveryComments: (state, action) => {
      const userInput = action.payload;

      if (userInput.length <= 200) {
        state.deliveryComments = action.payload;
      }
    },
    setDataTransfer: (state, action) => {
      const {payload} = action;
      const {joiningForm} = state;
      joiningForm.move_data_by_law = payload === DATA_TRANSFER_ENUM.BY_LAW.state;
      joiningForm.move_data_to_person = payload === DATA_TRANSFER_ENUM.TO_PERSON.state;
      joiningForm.dont_move_data = payload === DATA_TRANSFER_ENUM.DONT_MOVE.state;
    },
    setDataTransferName: (state, action) => {
      const {payload} = action;
      const {joiningForm} = state;
      joiningForm.person_data_move = payload;
    },
    setAcceptDataDownload: (state, action) => {
      state.joiningForm.accept_data_download = action.payload;
    },
    setSubAgreement: (state, action) => {
      state.joiningForm.sub_agreement = action.payload;
    },
    setAcceptTerms: (state, action) => {
      state.joiningForm.accept_terms = action.payload;
    },
    setSignNameTerms: (state, action) => {
      state.joiningForm.sign_name_terms = action.payload;
    },
    setIHaveSignedWillingly: (state, action) => {
      state.joiningForm.i_have_signed_willingly = action.payload;
    },
    setSignNameWilling: (state, action) => {
      state.joiningForm.sign_name_willing = action.payload;
    },
    setAcceptSecurity: (state, action) => {
      state.acceptSecurity = action.payload;
    },
    setAcceptAuction: (state, action) => {
      state.acceptAuction = action.payload;
    },
    setIsShowAuction: (state, action) => {
      state.isShowAuction = action.payload;
    },
    setIsShowSecurityForm: (state, action) => {
      state.isShowSecurityForm = action.payload;
    },

    setIsJoiningFormValid: (state, action) => {
      state.isJoiningFormValid = action.payload;
    },
    updateServiceAccessForm: (state, action) => {
      state.serviceAccessForm = action.payload;
      state.isServiceFormValid = true;
    },
    setProcessType: (state, action) => {
      state.processType = action.payload;
    },
    setIsLeasing: (state, action) => {
      state.isLeasing = action.payload;
    },
    setSelectedPhone: (state, action) => {
      state.selectedPhone = action.payload?.selectedPhone ?? action.payload;
    },
    setCreditDecision: (state, action) => {
      state.creditDecision = action.payload?.decisionSeq;
      state.nonSeparDepos = action.payload?.nonSeparDepos;
    },
    setFeatureList: (state, action) => {
      state.phoneFeatureList = action.payload;
    },
    setNotifyDeviceList: (state, action) => {
      state.notifyDeviceList = [...state.notifyDeviceList, action.payload];
    },
    setDeliverySlot: (state, action) => {
      const converted = convertStringToDateTime(action.payload);
      state.selectedDeliverySlot = {
        deliveryStartTime: converted.startDateTime,
        deliveryEndTime: converted.endDateTime,
        hebrewDayName: action.payload.hebrewDayName,
        deliveryLocationId: action.payload.deliveryLocationId,
        round: action.payload.selectedHours.round,
      };
    },
    setSimType: (state, action) => {
      state.simType = action.payload;
    },
    getRepId: (state) => {
      const urlParams = new URLSearchParams(window.location.search);
      const repId = urlParams.get('repId');
      if (repId) {
        state.repId = decodeURIComponent(repId);
      }
    },
  },
  extraReducers: {
    [InsertOrderDetails.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        handleOrderSuccess(state, action);
        if (action.payload.extra) {
          state.magicLink = action.payload.extra;
        }
      } else {
        state.errorReason = action.payload.codeError;
      }

      return state;
    },
    [InsertOrderDetailsPhoneUpgrade.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        handleOrderSuccess(state, action);
      }
      return state;
    },

    [GetUserDetails.fulfilled]: (state, action) => {
      if (action.payload != null) {
        state.userDetails = action.payload.userDetails;
        state.orderDetails = action.payload.orderDetails;
        state.canUpgradePhone = action.payload.canUpgradePhone;
      }
    },
    [GetDetailsDeviceUpgrade.fulfilled]: (state, action) => {
      if (action.payload != null) {
        state.userDetails = action.payload.userDetails;
        state.orderDetails = action.payload.orderDetails;
        state.canUpgradePhone = action.payload.canUpgradePhone;
        state.deviceUpgradeProcessing = true;
        state.transactionStatusId = action.payload.transactionStatusId;
        state.processType = 'DEVICE';
        if (action.payload.canUpgradePhone) {
          state.steps.current = PathHistory.DeviceSelectionStep1;
          state.selectedEmail = action.payload.orderDetails.email;
        }
      }
    },
    [GetUserSignatureForm.fulfilled]: (state, action) => {
      state.joiningForm = {...action.payload.terms, isNewAuctionSolider: action.payload.isNewAuctionSolider};
    },
    [GetDeliverySlotsByAdress.fulfilled]: (state, action) => {},
    [IsCellcomNumber.fulfilled]: (state, action) => {},
    [IsExternalCompanyNumber.rejected]: (state, action) => {},
    [IsExternalCompanyNumber.pending]: (state, action) => {},
    [IsExternalCompanyNumber.fulfilled]: (state, action) => {},
    [GetCitiesServiceCenters.fulfilled]: (state, action) => {
      if (action.payload) {
        state.citiesServiceCenters = action.payload?.citiesServiceCenters;
        state.pickupDate = action.payload?.pickupDate;
      }
    },
  },
});

export const {
  setStep,
  goToPage,
  setCurrentStep,
  saveToHistory,
  setSelectedPackage,
  setLineType,
  setLineNumber,
  setPersonalInfoMode,
  setSelectedAddress,
  setSelectedEmail,
  setSelectedPhoneNumber,
  setConfirmMail,
  setMailbox,
  setIsShowHeader,
  setPostalCode,
  setDeliveryMode,
  setIsUsePersonalInfoAddress,
  setIsSimInMailBox,
  setDeliverySelectedFullName,
  setDeliverySelectedPhoneNumber,
  setDeliveryComments,
  setDeliverySelectedAddress,
  setPickupServiceCenter,
  setDataTransfer,
  setDataTransferName,
  setAcceptDataDownload,
  setSubAgreement,
  setAcceptTerms,
  setSignNameTerms,
  setIHaveSignedWillingly,
  setSignNameWilling,
  setAcceptSecurity,
  setAcceptAuction,
  setIsJoiningFormValid,
  updateServiceAccessForm,
  setProcessType,
  setIsLeasing,
  setSelectedPhone,
  setNotifyDeviceList,
  setDeliverySlot,
  setSimType,
  setIsShowSecurityForm,
  setIsShowAuction,
  setFeatureList,
  pushToHistory,
  setCreditDecision,
  getRepId,
  clearHistory,
} = idfSaleBlockSlice.actions;
export default idfSaleBlockSlice.reducer;

const handleOrderSuccess = (state, action) => {
  state.isSaleDone = true;
  state.userDetails.sap_order_no = action.payload.sapOrderNumber;
  state.userDetails.esim_sap_order_no = action.payload.esimSapOrderNumber;
};
